<template>
	<div class="setting-row">
		<div class="setting-block" v-if="account_type == 'company_admin'">
			<div class="stting-block__inner">
				<div class="setting-block__inner__row">
					<h2>サービス管理責任者</h2>
				</div>
				<div class="setting-block__inner__row">
					<router-link class="button" to="#">新規部門作成</router-link>
					<router-link class="button" to="#">新規ユーザー作成</router-link>
					<router-link class="button" to="#">企業初期設定</router-link>
					<router-link class="button" to="#">DB管理</router-link>
					<router-link class="button" :to="{ name: 'erp_users' }">社員一覧</router-link>
				</div>
			</div>
		</div>
		<div class="setting-block" v-if="account_type == 'company_admin'">
			<div class="setting-block__inner">
				<div class="setting-block__inner__row">
					<h2>社内共通設定</h2>
				</div>
				<div class="setting-block__inner__row">
					<router-link class="button" :to="{ name: 'erp_user_new' }">社員追加</router-link>
					<router-link class="button" :to="{ name: 'erp_users' }">社員一覧</router-link>
					<router-link class="button" to="#">社員権限変更</router-link>
				</div>
			</div>
		</div>
		<div class="setting-block">
			<div class="setting-block__inner">
				<div class="setting-block__inner__row">
					<h2>個人設定</h2>
				</div>
				<div class="setting-block__inner__row">
					<router-link class="button" :to="{ name: 'erp_users_edit', params: { id: user_id } }"
						>個人情報編集</router-link
					>
					<router-link class="button" :to="{ name: 'password_edit' }">パスワード変更</router-link>
					<router-link class="button" :to="{ name: 'account_edit' }">アカウント設定</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			account_type: this.$store.getters["auth/authData"].account_type,
			user_id: this.$store.getters["auth/authData"].id,
		}
	},
}
</script>

<style lang="scss" scoped>
@import "../../stylesheet/erp/erp_setting.scss";
</style>
